/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Custom_Pages_UrlInputs */

const en_tables_custom_pages_url = /** @type {(inputs: Tables_Custom_Pages_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pages URL`)
};

const de_tables_custom_pages_url = /** @type {(inputs: Tables_Custom_Pages_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL`)
};

/**
* | output |
* | --- |
* | "Pages URL" |
*
* @param {Tables_Custom_Pages_UrlInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_custom_pages_url = /** @type {((inputs?: Tables_Custom_Pages_UrlInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Custom_Pages_UrlInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_custom_pages_url(inputs)
	return de_tables_custom_pages_url(inputs)
});